import { PropsWithChildren, createContext } from 'react'
import { useGenericStrictContext } from 'utils/createContext'
import { CIMSNotificationsProps } from './types'
import { NotificationEventItem } from '@cims-online/shared'
import { Store } from 'antd/lib/form/interface'

const Context = createContext(null)

type CIMSNotificationsContext<
  T extends NotificationEventItem,
  U extends Store
> = Pick<
  CIMSNotificationsProps<T, U>,
  'loading' | 'edit' | 'view' | '__debug' | 'prefix' | 'onReload'
>

export function useCIMSNotificationsContext<
  Event extends NotificationEventItem,
  InitialValues extends Store
>() {
  return useGenericStrictContext<
    CIMSNotificationsContext<Event, InitialValues>
  >(Context, 'CIMSNotificationsContext')
}

function CIMSNotificationsProvider<
  Event extends NotificationEventItem,
  InitialValues extends Store
>({
  children,
  ...rest
}: PropsWithChildren<CIMSNotificationsContext<Event, InitialValues>>) {
  return (
    <Context.Provider value={rest as unknown as null}>
      {children}
    </Context.Provider>
  )
}

export default CIMSNotificationsProvider
